module.exports = __webpack_public_path__ + "static/media/change-coinTBN.ce6ad267.png";